<template>
  <SectionPanel :title="{ value: highlightsTitle }">
    <template #sectionPanelContent>
      <div class="flex flex-col w-full gap-4">
        <div
          v-for="(item, itemIndex) in highlights"
          :key="itemIndex"
          :class="{
            'border-b border-racq-white': itemIndex + 1 < props.highlights.length,
          }"
          class="flex gap-4"
        >
          <div v-if="showNumber">
            <span
              class="grid h-[24px] w-[24px] place-items-center rounded-full bg-gray-600 text-xs text-white text-xs-bold"
            >
              {{ itemIndex + 1 }}</span
            >
          </div>
          <div
            class="text-m text-racq-dark-grey"
            :class="[!isLastItem(itemIndex) ? 'pb-4' : '', showNumber ? 'pl-4 md:pl-0' : '']"
            v-html="item.content"
          ></div>
        </div>
      </div>
    </template>
  </SectionPanel>
</template>
<script setup lang="ts">
import SectionPanel from '@/components/SectionPanel/SectionPanel.vue';
import { IHighlight } from '@/interfaces/forms/highlights-interface';

const props = defineProps<{
  showNumber: boolean;
  highlightsTitle: string;
  highlights: IHighlight[];
}>();

const isLastItem = (itemIndex: number) => {
  return itemIndex + 1 === props.highlights.length;
};
</script>
